import React from "react";
import "../Css/about.css";

const About = () => {
  return (
    <section className="about-us">
      <div className="about-container">
        <h2 className="about-title">Quiénes Somos</h2>
        <p className="about-description">
          Somos un estudio <strong>100% Argentino</strong>, que ofrece un Servicio Integral para tu proyecto digital: diseño web, diseño gráfico, fotografía y SEO. Desde el primer boceto hasta el lanzamiento.
        </p>
        <h3 className="about-subtitle">Nuestros Compromisos</h3>
        <div className="about-highlights">
          <div className="highlight-card">
            <div className="highlight-card-middle">
              <div className="highlight-card-inner">
                <h3>Integral</h3>
                <p> Servicios completos que cubren desde el diseño y desarrollo hasta la implementación y mantenimiento, asegurando soluciones web robustas.</p>
              </div>
            </div>
          </div>
          <div className="highlight-card">
            <div className="highlight-card-middle">
              <div className="highlight-card-inner">
                <h3>Escalabilidad</h3>
                <p>Arquitecturas flexibles que permiten crecer junto con tu negocio, adaptándose a picos de tráfico y nuevas funcionalidades.</p>
              </div>
            </div>
          </div>
          <div className="highlight-card">
            <div className="highlight-card-middle">
              <div className="highlight-card-inner">
                <h3>Accesible</h3>
                <p>Soluciones web económicas y fáciles de implementar, pensadas para que cualquier proyecto pueda hacerse realidad sin complicaciones.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
